import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  Icon,
  Typography,
  ButtonBase,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import MainMenu from '../../../components/MainMenu';
import { useAppointments } from '../context';
import useStyles from './styles';
import Loading from './Loading';
import Steps from './Steps';

const TopBar = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isTabletScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { handleShowSideMenu, isSchedulerPage, infos } = useAppointments();
  const [loading, setLoading] = useState({
    general: true,
    updateCompleted: false,
  });

  useEffect(() => {
    if (infos.loaded) {
      setLoading(oldLoading => ({ ...oldLoading, general: false }));
    }
  }, [infos.loaded]);

  return (
    <>
      {loading.general ? (
        <Loading />
      ) : (
        <>
          <Box
            className={`${classes.container} ${
              isSchedulerPage && 'with-steps'
            }`}
          >
            <Box className="btn-icon-right-wrapper">
              {isSmallScreen && <MainMenu />}
            </Box>
            <Box className="text-title-container">
              <Typography
                className="text-title"
                variant="subtitle1"
                noWrap
                onClick={isSmallScreen ? handleShowSideMenu : null}
              >
                Agendamentos
              </Typography>
            </Box>
            {isSchedulerPage && <Steps className="steps" />}
            {isTabletScreen && (
              <IconButton
                size="medium"
                className="btn-toggle-sidemenu"
                onClick={handleShowSideMenu}
              >
                <Icon>menu_open</Icon>
              </IconButton>
            )}
            {!isSchedulerPage && (
              <ButtonBase
                className="btn-schedule"
                to="/appointments/new"
                component={Link}
              >
                <Icon className="btn-schedule-icon">schedule</Icon>
                <Typography className="btn-schedule-text" variant="caption">
                  Agendar horário
                </Typography>
              </ButtonBase>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default TopBar;
